export default __webpack_public_path__ + "static/media/clear-sans-all-400-normal.72f3056d.woff";